import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { InvoiceService } from './invoice.service';
import { ListInvoiceService } from './list.service';

import { IFInvoice, IFProjectInvoicesResponse, IFAcumulat } from './invoice.interfaces';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-invoice',
  templateUrl: 'invoices.component.html',
  styleUrls: ['invoices.component.scss']
})
export class InvoicesComponent implements OnInit, OnDestroy {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  private routeParamsSubs: any;

  public showAsyncProgress: boolean = false;
  public invoicingData: Array<IFProjectInvoicesResponse>;
  public acumulat : Array<IFAcumulat> = [];

  private activeFilters: any = {};
  private currentOrdering: any = {};
  private unsubscriber : Subject<void> = new Subject<void>();
  
  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  public data: Array<number> = [];

  public showFilters: boolean = true;
  public orderingParameters: any;
  public invoiceTable: string = 'invoice';

  public toggleFiltersVisibility() {
    this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
     this.activeFilters = $event;

     this.firstRegisterShown = 1 + this.listInvoiceService.currentPage * this.listInvoiceService.rowsPerPage;
     this.requestRowsToParent();
   }

   private computeDisplayedRows(): void {
     this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listInvoiceService.rowsPerPage - 1, this.invoicingData.length);
   }

   private requestRowsToParent(): void {
     this.route.params.subscribe(params => {
       this.invoiceService.get(this.invoiceTable, this.listInvoiceService.currentPage*this.listInvoiceService.rowsPerPage,this.listInvoiceService.rowsPerPage, { //FILTRE DELS TREBALLS QUE ES MOSTREN A INICI (Actius)
         data_factura_ini: this.activeFilters['data_factura_ini'] +'-01-01',
         data_factura_fi: this.activeFilters['data_factura_fi']+'-12-31'
       }
       ,//Funció a aplicar. Per defecte LIKE %%
       {
         'cnd_data_factura_ini': ' > ',
         'cnd_data_factura_fi': ' < '
       },
       { //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
       }).subscribe(
           data => {
              this.invoicingData = data;
              this.acumulat.length=0;
              for(let i=0; i<this.invoicingData.length;i++){
               this.acumulat.push(this.acumulaFactures(this.invoicingData[i].invoices));
              }
           },
           error => console.log(error)
         );
     });
   }

   public requestPrevious(): void {
     this.listInvoiceService.currentPage = Math.max(0, this.listInvoiceService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public requestNext(): void {
     this.listInvoiceService.currentPage = this.listInvoiceService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public setRowPerPage(rowsPerPage: number) {
     this.listInvoiceService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
   }

  private acumulaFactures(invoiceList: Array<any>): IFAcumulat {
    let Tacum: IFAcumulat = {facturat: 0, cobrat: 0, percent: 0};
    return invoiceList
      .filter(invoice => !Number.isNaN(invoice.facturacio_prevista_eur))
      .reduce((acum, invoice) => {
      if (invoice.data_factura) {
        Tacum.facturat += invoice.facturacio_prevista_eur;
        Tacum.percent += invoice.facturacio_prevista_percent;
      }
      if(invoice.data_cobrament && invoice.numero_factura > 36) {
        Tacum.cobrat += invoice.facturacio_prevista_eur;
        //console.log("cobrat "+Tacum.cobrat+"   "+invoice.projecte_codi);
      }
      return Tacum;
      }, {
        facturat: 0,
        cobrat: 0,
        percent: 0
      });
  }

  public invoiceFilters: Array<any>
  public ordreCamps: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, private listInvoiceService: ListInvoiceService, private invoiceService: InvoiceService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.ordreCamps = ['data_aprovacio'];
    this.invoiceFilters = [
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
            {
              text: 'Any',
              name: 'data_factura_ini',
              value: this.listInvoiceService.data_factura_ini
            },
            {
              text: 'Any final',
              name: 'data_factura_fi',
              value: this.listInvoiceService.data_factura_fi
            }
          ]
        }
      ]
    }
  ];

  this.routeParamsSubs = this.route.params.subscribe(params => {
   this.route.params.subscribe(params => {
     this.invoiceService.get(this.invoiceTable, this.listInvoiceService.currentPage*this.listInvoiceService.rowsPerPage,this.listInvoiceService.rowsPerPage, { //FILTRE DELS TREBALLS QUE ES MOSTREN A INICI (Actius)
       data_factura_ini: this.listInvoiceService.data_factura_ini +'-01-01',
       data_factura_fi: this.listInvoiceService.data_factura_fi+'-12-31'
     }
     ,//Funció a aplicar. Per defecte LIKE %%
     {
       'cnd_data_factura_ini': ' > ',
       'cnd_data_factura_fi': ' < '
     },
     {//ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
     }).subscribe(
         data => {
           this.invoicingData = data;
           for(let i=0; i<this.invoicingData.length;i++){
             this.acumulat.push(this.acumulaFactures(this.invoicingData[i].invoices));
           }
         },
         error => console.log(error)
       );
   });
  });
  
  history.pushState(null,  document.title, location.href);

  fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
  ).subscribe((_) => {
      history.pushState(null, '');
  });

  }

  ngOnDestroy() {
    this.routeParamsSubs.unsubscribe();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
